// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__OSYEA","title":"Info_title__1nQMC","selects":"Info_selects__iQ1fG","requiredAsterisk":"Info_requiredAsterisk__1N27h"};